import * as $          from 'jquery';
import { onLoad, onClick, onResizeWindow }     from 'Core/Events';

export const MobileNav = (() => {

    const Selector = {
        BODY:       'body',
        HEADER_STICKY: '.header-sticky',
        HEADER_ROW_2: '#header-row-2',
        MOBILE_NAV: '.header-b-menu',
        MOBILE_HEADER_B: '.header-b-mobile',
        TOGGLER:    '.js_mobile-nav_toggler',
        MENU_SUBLINK: '.header-b-menu--main-sublink',
    };
    const MENU_OPEN_CLASS = 'menu-open';
    const MOBILENAV_VISIBLE_CLASS: string = 'header-b-mobile--visible';
    const MOBILENAV_HIDDEN_CLASS: string  = 'header-b-mobile--hidden';
    let primaryWidth: number;

    onClick(Selector.TOGGLER, toggleVisibility);
    onClick(Selector.MENU_SUBLINK, addPrimaryColorClass);
    $(Selector.MENU_SUBLINK).on('touchstart touchend', addPrimaryColorClass);
    onResizeWindow(hide);
    onLoad(detectWindowWidth);
    


    function toggleVisibility() {
        if ($(Selector.HEADER_STICKY).hasClass(MENU_OPEN_CLASS)) {
            hide();
        } else {
            show();
        }
    }

    function show() {
        // Calculate header offset (bottom of header-row-2 relative to viewport)
        const headerRow2 = $(Selector.HEADER_ROW_2);
        if (headerRow2.length) {
            const rect = headerRow2[0].getBoundingClientRect();
            const offset = rect.bottom;
            document.documentElement.style.setProperty('--header-offset', `${offset}px`);
        }
        
        // Add menu-open class to sticky header container
        $(Selector.HEADER_STICKY).addClass(MENU_OPEN_CLASS);
        
        $(Selector.MOBILE_NAV)
            .removeClass(MOBILENAV_HIDDEN_CLASS)
            .addClass(MOBILENAV_VISIBLE_CLASS)
            .addClass('d-flex');
        $(Selector.BODY).addClass('overflow-hidden');
    }

    function hide() {
        //prevent to hide menu on scroll event - problem found on Iphone 13
        if(navigator.userAgent.match(/(iPod|iPhone|iPad)/) && event.type == 'resize' && primaryWidth == $(window).width()) {
            
        } else {
            hidemenuMechanics()
        }
    }

    function hidemenuMechanics() {
        $(Selector.MOBILE_NAV)
            .removeClass(MOBILENAV_VISIBLE_CLASS)
            .addClass(MOBILENAV_HIDDEN_CLASS)
            .removeClass('d-flex');
        $(Selector.HEADER_STICKY).removeClass(MENU_OPEN_CLASS);
        $(Selector.BODY).removeClass('overflow-hidden');
        $(Selector.MOBILE_NAV + " ul > li > ul").removeClass("show");
    }

    function addPrimaryColorClass() {
        $(this).addClass('text-primary').css('color', '#B71227');
    }

    function detectWindowWidth() {
        primaryWidth = $(window).width();
    }

})();
import * as $          from 'jquery';
import { onLoad, onClick, onResizeWindow }     from 'Core/Events';

export const MobileNav = (() => {

    const Selector = {
        BODY:       'body',
        HEADER_STICKY: '.header-sticky',
        HEADER_ROW_2: '#header-row-2',
        MOBILE_NAV: '.header-b-menu',
        MOBILE_HEADER_B: '.header-b-mobile',
        TOGGLER:    '.js_mobile-nav_toggler',
        MENU_SUBLINK: '.header-b-menu--main-sublink',
    };
    const MENU_OPEN_CLASS = 'menu-open';
    const MOBILENAV_VISIBLE_CLASS: string = 'header-b-mobile--visible';
    const MOBILENAV_HIDDEN_CLASS: string  = 'header-b-mobile--hidden';
    let primaryWidth: number;

    onClick(Selector.TOGGLER, toggleVisibility);
    onClick(Selector.MENU_SUBLINK, addPrimaryColorClass);
    $(Selector.MENU_SUBLINK).on('touchstart touchend', addPrimaryColorClass);
    onResizeWindow(hide);
    onLoad(detectWindowWidth);
    


    function toggleVisibility() {
        if ($(Selector.HEADER_STICKY).hasClass(MENU_OPEN_CLASS)) {
            hide();
        } else {
            show();
        }
    }

    function show() {
        // Calculate header offset (bottom of header-row-2 relative to viewport)
        const headerRow2 = $(Selector.HEADER_ROW_2);
        if (headerRow2.length) {
            const rect = headerRow2[0].getBoundingClientRect();
            const offset = rect.bottom;
            document.documentElement.style.setProperty('--header-offset', `${offset}px`);
        }
        
        // Add menu-open class to sticky header container
        $(Selector.HEADER_STICKY).addClass(MENU_OPEN_CLASS);
        
        $(Selector.MOBILE_NAV)
            .removeClass(MOBILENAV_HIDDEN_CLASS)
            .addClass(MOBILENAV_VISIBLE_CLASS)
            .addClass('d-flex');
        $(Selector.BODY).addClass('overflow-hidden');
    }

    function hide() {
        //prevent to hide menu on scroll event - problem found on Iphone 13
        if(navigator.userAgent.match(/(iPod|iPhone|iPad)/) && event.type == 'resize' && primaryWidth == $(window).width()) {
            
        } else {
            hidemenuMechanics()
        }
    }

    function hidemenuMechanics() {
        $(Selector.MOBILE_NAV)
            .removeClass(MOBILENAV_VISIBLE_CLASS)
            .addClass(MOBILENAV_HIDDEN_CLASS)
            .removeClass('d-flex');
        $(Selector.HEADER_STICKY).removeClass(MENU_OPEN_CLASS);
        $(Selector.BODY).removeClass('overflow-hidden');
        $(Selector.MOBILE_NAV + " ul > li > ul").removeClass("show");
    }

    function addPrimaryColorClass() {
        $(this).addClass('text-primary').css('color', '#B71227');
    }

    function detectWindowWidth() {
        primaryWidth = $(window).width();
    }

})();
